"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FormFieldFromProps_1 = __importDefault(require("@Fields/v2/FormFieldFromProps"));
const IdentifiersSection = (props) => {
    const { hfaPublisherNumber, ipiNumber, isni, identifierToolTip } = props;
    return (react_1.default.createElement("div", { className: "identifiers-section" },
        react_1.default.createElement("h5", null,
            "Identifiers",
            identifierToolTip),
        hfaPublisherNumber && react_1.default.createElement(FormFieldFromProps_1.default, { field: hfaPublisherNumber }),
        ipiNumber && react_1.default.createElement(FormFieldFromProps_1.default, { field: ipiNumber }),
        isni && react_1.default.createElement(FormFieldFromProps_1.default, { field: isni })));
};
exports.default = IdentifiersSection;
